import axios from "axios";

const apiUrl = `${process.env.REACT_APP_API_URL}/api/dojos`;
const token = localStorage.getItem("token");

/// GET
// Fonction pour récupérer tous les dojos
export const getDojos = async () => {
  try {
    const response = await axios.get(`${apiUrl}/alldojos`, {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });
    return response.data;
  } catch (error) {
    console.error("Erreur lors du chargement des dojos:", error);
  }
};

// Compter le nolbre de dojos
export const countDojos = async () => {
  try {
    const response = await axios.get(`${apiUrl}/countdojos`, {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });
    return response.data;
  } catch (error) {
    console.error("Erreur lors du comptage des dojos:", error);
  }
};

// Fonction pour récupérer un dojo par son id
export const getDojoById = async (dojoId) => {
  try {
    const response = await axios.get(`${apiUrl}/${dojoId}`, {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });
    return response.data;
  } catch (error) {
    console.error("Erreur lors du chargement du dojo:", error);
  }
};

// Fonction pour obtenir les dojo d'un club par son id
export const getDojosByClub = async (clubId) => {
  try {
    if (!clubId) {
      console.error("❌ Erreur : clubId est undefined !");
      return [];
    }

    const url = `${apiUrl}/club/${clubId}`;
    console.log(`🔹 Envoi de la requête GET : ${url}`);

    const response = await axios.get(url);

    return Array.isArray(response.data) ? response.data : [];
  } catch (error) {
    console.error("❌ Erreur lors du chargement des dojos du club :", error);
    return [];
  }
};

// Fonction pour trouver les dojos d'un teacher
export const getDojosByTeacher = async (teacherId) => {
  try {
    const response = await axios.get(`${apiUrl}/teacher/${teacherId}`, {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });
    return response.data;
  } catch (error) {
    console.error("Erreur lors du chargement des dojos du teacher:", error);
  }
};

/// POST
// Fonction pour créer un dojo
export const createDojo = async (dojoData) => {
  try {
    await axios.post(`${apiUrl}/createdojo`, dojoData, {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });
  } catch (error) {
    console.error("Erreur lors de la création du dojo:", error);
  }
};

/// PUT
// Fonction pour modifier un dojo
export const updateDojo = async (dojoId, dojoData) => {
  try {
    await axios.put(`${apiUrl}/updatedojo/${dojoId}`, dojoData, {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });
  } catch (error) {
    console.error("Erreur lors de la modification du dojo:", error);
  }
};

/// DELETE
// Fonction pour supprimer un dojo
export const deleteDojo = async (dojoId) => {
  try {
    await axios.delete(`${apiUrl}/deletedojo/${dojoId}`, {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });
  } catch (error) {
    console.error("Erreur lors de la suppression du dojo:", error);
  }
};
